import { render, staticRenderFns } from "./LiftFormDataTable.vue?vue&type=template&id=8fbe0830&"
import script from "./LiftFormDataTable.vue?vue&type=script&lang=js&"
export * from "./LiftFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports